export default __webpack_public_path__ + "static/media/2308.235fd08b.png";